@if (!hasFormPermission()) {
    <app-no-permission />
} @else {
    <section class="flex flex-col h-full gap-7">
        <div class="flex">
            <app-management-main-panel-title
                [icon]="['fas', 'bars-sort']"
                [title]="'form'" />
        </div>

        <div class="flex flex-col gap-1 flex-1 min-h-0">
            <app-forms-list class="flex flex-1 min-h-0" />
        </div>
    </section>
}
